import { AnnotationsOverlayService } from './annotations-overlay/annotations-overlay.service';
import { AnnotationsContextMenuStore } from './state/annotations-context-menu.store';

export const ANNOTATIONS_CONTEXT_MENU_PROVIDERS = [
  AnnotationsOverlayService,
  AnnotationsContextMenuStore,
];
